<template>
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.7 15.25L1 9.54998L2.15002 8.39995L6.70005 12.95L16.15 3.5L17.3 4.64998L6.7 15.25Z" fill="#30B648"/>
  </svg>
</template>